'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BaseMenuItem = require('./BaseMenuItem');

var _BaseMenuItem2 = _interopRequireDefault(_BaseMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BaseMenuItem2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuItem/index.js
// module id = 168
// module chunks = 0